export const BACKEND_URL = 'https://backend.masakenapp.com';
export const LOGOUT_BASE = 'https://besht-dashboard.masakenapp.com/control-panal';
